import React from "react";
import styled from "styled-components";
import Input from "../atoms/Input";
import InputLabel from "../atoms/InputLabel";
import { color } from "../templates/ui";

const StyledFormItem = styled.div`
  position: relative;

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    right: 8px;
    width: 30px;
    height: 30px;
    transform: translateY(-50%);
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+ICAgIDxnIGZpbGw9IiNGRkYiIGZpbGxSdWxlPSJldmVub2RkIj4gICAgICAgIDxwYXRoICAgICAgICAgICAgICAgIGQ9Ik0xMC43ODEgMjEuNTYzQTEwLjc2NyAxMC43NjcgMCAwIDEgMCAxMC43OCAxMC43NjcgMTAuNzY3IDAgMCAxIDEwLjc4MSAwYTEwLjc2NyAxMC43NjcgMCAwIDEgMTAuNzgxIDEwLjc4MSAxMC43NjcgMTAuNzY3IDAgMCAxLTEwLjc4IDEwLjc4MXptMC0yMC4xMjVhOS4zMjUgOS4zMjUgMCAwIDAtOS4zNDQgOS4zNDMgOS4zMjUgOS4zMjUgMCAwIDAgOS4zNDQgOS4zNDQgOS4zMjUgOS4zMjUgMCAwIDAgOS4zNDQtOS4zNDQgOS4zMjUgOS4zMjUgMCAwIDAtOS4zNDQtOS4zNDR6IiAgICAgICAgICAgICAgICBmaWxsUnVsZT0ibm9uemVybyIgICAgICAgIC8+ICAgICAgICA8cGF0aCBkPSJNMjcuNjI2IDI5LjA2M2MtLjM0OSAwLS42OTgtLjE0LS45NzctLjQyMmwtOS41NjUtOS40NzVhLjY4MS42ODEgMCAwIDEgMC0uOTgzYy4yOC0uMjguNjk5LS4yOC45NzggMGw5LjU2NCA5LjQ3Ni45NzgtLjk4My05LjQ5NS05LjU0NWEuNjgxLjY4MSAwIDAgMSAwLS45ODNjLjI4LS4yOC42OTgtLjI4Ljk3NyAwbDkuNDk1IDkuNTQ2Yy4yOC4yOC40MTkuNjMxLjQxOS45ODJzLS4xNC43MDItLjQxOS45ODNsLS45NzcuOTgyYy0uMjguMjgxLS42MjkuNDIyLS45NzguNDIyeiIgLz4gICAgPC9nPjwvc3ZnPg==);
    background-repeat: no-repeat;
    background-size: cover;
    pointer-events: none;

    .filter-canvas & {
      background-image: url(data:image/svg+xml;base64,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);
    }
  }
`;

const IconWrapper = styled.input`
  display: ${props => (props.icon !== "" ? "block" : "none")};
  position: absolute;
  bottom: 0;
  right: 0;
  width: 48px;
  height: 48px;
  background-color: ${color.primary.base};
  outline: none;
  border: none;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
  appearance: none;
  border-radius: 0;

  .filter-canvas & {
    background-color: transparent;
    pointer-events: none;
  }

  &:hover {
    background-color: ${color.primary.darker};
  }
`;

const InputItem = ({ placeholder, inputType, labelText, className, icon, onChange, value, onClick, ...props }) => (
  <>
    <InputLabel>{labelText}</InputLabel>
    <StyledFormItem className={className}>
      <form id="searchInternational">
        <Input
          placeholder={placeholder}
          inputType={inputType}
          icon={icon}
          value={value}
          onChange={onChange}
          {...props}
        />
        <IconWrapper type="submit" value="" onClick={onClick} />
      </form>
    </StyledFormItem>
  </>
);

export default InputItem;
